import { Tabs } from 'common/constants';
import { PrintChecksResponse } from 'pages/VendorsTablePage/components/PrintChecks/types';
import { apiService } from '../apiService';
import { METHOD, PATHS } from '../constants';
import { validateCompanyAndStore } from '../utils';
import type { HeaderData } from 'adapters/types';
import type { VendorsResponseDataType } from 'pages/VendorsTablePage/components/VendorsTable/types';

export const fetchHighVolumeVendors = async (
  headers: HeaderData,
  companyId: string,
  storeId: string,
  page: number,
  size: number,
  dueDate?: string,
  paymentMethod?: string,
  selectedTab?: string,
  searchValue?: string,
  sortColumn?: string,
  sortOrder?: string
): Promise<VendorsResponseDataType> => {
  const qsObject = {
    dueDate: dueDate || undefined,
    paymentMethod,
    page,
    size,
    search: searchValue || undefined,
    sortColumn,
    sortOrder
  };
  validateCompanyAndStore(companyId, storeId);
  const response = await apiService({
    url:
      selectedTab === Tabs.NeedsAuthorization
        ? PATHS.getHighVolumeVendorsNeedsAuthorizationPath(storeId)
        : PATHS.getHighVolumeVendorsToBePaidPath(storeId),
    method: METHOD.GET,
    headers: { ...headers, 'x-store-id': storeId },
    qsObject
  });
  if (response.ok)
    return (await response.json()) as Promise<VendorsResponseDataType>;
  throw new Error(response.statusText);
};

export const fetchHighVolumePrintAuthorizedVendors = async (
  headers: HeaderData,
  storeId: string,
  page: number,
  size: number,
  searchValue?: string,
  sortColumn?: string,
  sortOrder?: string
): Promise<PrintChecksResponse> => {
  const qsObject = {
    page,
    size,
    search: searchValue,
    sortColumn,
    sortOrder
  };
  const response = await apiService({
    url: PATHS.getHighVolumeVendorsPrintChecksPath(storeId),
    method: METHOD.GET,
    headers: { ...headers, 'x-store-id': storeId },
    qsObject
  });
  if (response.ok)
    return (await response.json()) as Promise<PrintChecksResponse>;
  throw new Error(response.statusText);
};
